import { configService } from '@web/services/singletons';

export const isDevEnvironment = (): boolean => {
    return configService.debugEnvName === 'local' || configService.debugEnvName === 'development';
};

export const isLocal = (): boolean => {
    return configService.debugEnvName === 'local';
};
